import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Footer } from '../../components/Footer';
import { Particle } from '../../components/Particles';
import { useParticles } from './useParticles';

type LandingTypes = {};

const Landing: React.FC<LandingTypes> = () => {
    const { t } = useTranslation();
    const { particleSettings } = useParticles();
    const hasWindow = typeof window !== 'undefined' ? true : false;
    let scrollbar: any = null;
    let smoothScroll: any = null;

    useEffect(() => {
        // eslint-disable-next-line curly
        if (!hasWindow) return;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        scrollbar = require('smooth-scrollbar');
        const plugin = require('../../functions/edgeScrollEasingPlugin');
        console.log('scroll', scrollbar);
        scrollbar.default.use(plugin.default);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        smoothScroll = scrollbar.default.init(document.querySelector('#am_scrollbar'), {
            thumbMinSize: 20,
            renderByPixels: true,
            continuousScrolling: false,
        });
        smoothScroll.addListener((s: any) => {
            console.log(s.offset);
            console.log(smoothScroll._momentum);
        });
        return () => {
            scrollbar && scrollbar.default.destroy(scrollbar);
        };
    }, [hasWindow]);

    useEffect(() => {
        console.log(particleSettings);
    }, [particleSettings]);

    return (
        <div id="am_route_content" className="landing">
            <Helmet
                defaultTitle="AutoMat | Sveriges Modernaste Matkedja"
                titleTemplate="%s AutoMat"
            />
            <div className="am_inner" id="am_scrollbar">
                <div className="am_particle_background">
                    <div id="am_particles">
                        {particleSettings!.map((p) => (
                            <Particle
                                key={p.key}
                                startPos={p.startPos}
                                endPos={p.endPos}
                                duration={p.duration}
                                ease={p.ease}
                                css={p.style}
                            />
                        ))}
                    </div>
                </div>
                <div className="am_landing_content">
                    <h1>{t('landing.message')}</h1>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Landing;
